import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SuggestionsResponse } from '../models/suggestion.model';
import { queryBuilder } from '@metromarkets/sdk';
import { API_SEARCH_SUGGESTIONS_ROUTE_V3 } from '../constants';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SearchSuggestionsService {

  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public loadSearchSuggestions(term: string): Observable<SuggestionsResponse> {
    const params = queryBuilder.toParams({
      q: term,
    }) as HttpParams;
    return this.http.get<SuggestionsResponse>(API_SEARCH_SUGGESTIONS_ROUTE_V3(), { params, headers: {
      'x-source': 'angular_search_suggestions'
      } })
      .pipe(map(response => SuggestionsResponse.map(response)));
  }
}
